/* Enhance the existing tabs/SliderElement without replacing either component. */
(() => {
  if (window.lfCollectionsEditorial) return;
  window.lfCollectionsEditorial = true;
  function initialise(root) {
    if (root.dataset.collectionsInitialised) return;
    root.dataset.collectionsInitialised = 'true';
    const tabs = root.querySelector('tabs-element');
    if (!tabs) return;
    const sync = () => {
      const buttons = [...tabs.querySelectorAll('[role="tab"]')];
      const index = Number(tabs.getAttribute('selected-index') || 0);
      buttons.forEach((button, i) => {
        button.setAttribute('aria-selected', String(i === index));
        button.disabled = false;
        button.tabIndex = i === index ? 0 : -1;
        if (tabs.hasAttribute('data-product-recommendations-tabs')) {
          const panel = document.getElementById(button.getAttribute('aria-controls'));
          button.id ||= `CollectionTab-${button.getAttribute('aria-controls')}`;
          panel?.setAttribute('aria-labelledby', button.id);
          if (panel) panel.inert = i !== index;
        }
      });
    };
    new MutationObserver(sync).observe(tabs, { attributes: true, attributeFilter: ['selected-index'] });
    root.addEventListener('keydown', event => {
      const tab = event.target.closest('[role="tab"]');
      if (tab && ['ArrowLeft', 'ArrowRight', 'Home', 'End'].includes(event.key)) {
        const buttons = [...tabs.querySelectorAll('[role="tab"]')];
        const current = buttons.indexOf(tab);
        const direction = getComputedStyle(root).direction === 'rtl' ? -1 : 1;
        const step = (event.key === 'ArrowRight' ? 1 : -1) * direction;
        const next = event.key === 'Home' ? 0 : event.key === 'End' ? buttons.length - 1 : (current + step + buttons.length) % buttons.length;
        event.preventDefault();
        buttons[next].click();
      }
      // Focusable links keep their normal keyboard behaviour.
      if (event.target.matches('slider-element') && ['ArrowLeft', 'ArrowRight'].includes(event.key)) {
        event.preventDefault();
        const direction = getComputedStyle(root).direction === 'rtl' ? -1 : 1;
        const forward = (event.key === 'ArrowRight' ? 1 : -1) * direction > 0;
        event.target.dispatchEvent(new CustomEvent(forward ? 'slider:next' : 'slider:previous'));
      }
    });
    sync();
  }
  const load = (scope = document) => scope.querySelectorAll('[data-collections-editorial]').forEach(initialise);
  load();
  document.addEventListener('recommendations:loaded', event => load(event.target));
  document.addEventListener('shopify:section:load', event => load(event.target));
})();
